import './AboutMe.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import naveen_picture from '../../assets/images/Naveen.jpg';

const AboutMe = (props) => {
    return <div className='brief-about'>
        <div className='brief-about-description'>
            <h1>Concise Introduction</h1>
            <p>Passionate software developer with expertise in back-end development and application development, crafting user-friendly websites and applications with clean code. Dedicated to staying ahead in technology trends, I aim to enhance user satisfaction through intuitive design and responsiveness.</p>
            <br />
            <p className='second-para'>Beyond coding, I explore design realms for constant inspiration. Let's connect and elevate your online presence together!</p>
            <a href='aboutMe' className="button">
                <span className="button_lg">
                    <span className="button_sl"></span>
                    <span className="button_text">Know About Me &nbsp;&nbsp;<FontAwesomeIcon icon={faAngleRight} /></span>
                </span>
            </a>
        </div>
        <div className='naveen-img-div'>
            <picture>
                <img className='naveen' src={naveen_picture} alt='Naveen' />
            </picture>
        </div>
    </div>
}

export default AboutMe;
